import { makeStyles } from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState } from "react";
import { getTasks } from "../apis/monitor-data";
import useStyles from "./muistyles";
import { getBotLogSummary,getBotLogDetail} from "../apis/bots";
import Loading from "./Loading";
import { RefreshButton } from "./GenericReusableComponents/HTMLWrappers";
import {Table} from "./GenericReusableComponents/Table";
import Grid from "@mui/material/Grid";

import {SelectEnvironment} from "./GenericReusableComponents/HTMLWrappers"


export default function Monitor() {
  const [botLogSummary, setBotLogSummary] = useState([]);
  const [filteredBotLogSummary, setFilteredBotLogSummary] = useState([]);
 
  const [botLogSummaryChanged,setBotLogSummaryChanged] = useState(false);
  const [selectedBot,setSelectedBot] = useState({});
  const [loading,setLoading] = useState(false);
    
  const classes = useStyles();
  const[selectedEnv,setSelectedEnv] = useState("PROD");


  useEffect(() => {
    let mounted = true;
    if(botLogSummary.length && !botLogSummaryChanged){
      return;
    }
    setLoading(true);
    getBotLogSummary().then((json) => {
      console.log(`Bot Logs : ${JSON.stringify(json.data)}`)
      if(Array.isArray(json.data)){
        if (mounted) {
          var fBotLogs = [];
          var bl = [...json.data];
          bl.forEach(i=>{
            let sdt = new Date(i.startTime);
            // i.startTime = sdt.toString();

            let edt = new Date(i.endTime)
            // i.endTime = edt.toString();

            fBotLogs.push(i);
          })
          setBotLogSummary(bl);
          
         
          console.log("Filtered botLogs "+ JSON.stringify(fBotLogs));
          setFilteredBotLogSummary(fBotLogs);
          if(bl.length !=0) {
            getBotLogDetail(bl[0].requestId).then(jsonbld=>{
              
              let fbl = {...bl[0]};
              // fbl.logDetail = [...jsonbld.data];
              let logDetail = [...jsonbld.data];

              console.log(`Before sorting ${JSON.stringify(logDetail)}`);
              logDetail.sort((firstb,secondb)=> new Date(firstb.logTime).getTime() - new Date(secondb.logTime).getTime());
              console.log(`After sorting ${JSON.stringify(logDetail)}`)
              fbl.logDetail = logDetail;
              setSelectedBot(fbl);
            })
            
          }
        }
      }else{
        setBotLogSummary([]);
        setFilteredBotLogSummary([]);
        
      }
      setLoading(false);
      setBotLogSummaryChanged(false);
    });
    return () => {console.log("Monitor is unmounted"); mounted = false};
  }, [botLogSummaryChanged]);

  function filterTable(filterString) {
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredBotLogSummary(botLogSummary);
      // setQ("");
    } else {
      // setQ(filterString);
      setFilteredBotLogSummary(
        botLogSummary.filter((botSummaryItem) => {
          if (botSummaryItem.botName.startsWith(filterString)) return true;

          if (botSummaryItem.description.startsWith(filterString)) return true;
          
          if(botSummaryItem.lastRun.startsWith(filterString)) return true;

          if (botSummaryItem.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(botSummaryItem);
        })
      );
    }
  }

  function onClickBotCardHandler(botLog){
    console.log("onClickBotCardHandler");
    
    setLoading(true);
    getBotLogDetail(botLog.requestId).then((json)=>{
      botLog.logDetail = json.data;
      setSelectedBot(botLog);
      setLoading(false);
      
    })

  }
  const BotCard=({botLog})=>{
    let bstyle = {
      cursor:'pointer',
      backgroundColor: botLog.status === "OK" ? 'lightGreen':'Red',
      padding:'10px',
      margin:'0px',
      borderRadius:'5px',
      // border: selectedBot.botName ===  botLog.botName?'1px solid  blue': '0px'
      backgroundColor: selectedBot.botName ===  botLog.botName?'lightgrey': '#f4f4f4'
    }
    
    

    return(

    <div style={bstyle} onClick={()=>onClickBotCardHandler(botLog)}>
      <span style={{fontSize:'16px',fontWeight:'bold'}}>{botLog.botName}</span><br/>
      <div style={{fontSize:'15px'}}>
        Description: {botLog.description}<br/>
        Status: {botLog.status}<br/>
        Start time: {botLog.startTime}<br/>
        End Time:{botLog.endTime}<br/>
      </div>
      
    </div>
    )
  }

  const BotLogDetail=({bot})=>{
    // console.log("BotLogDetail "+JSON.stringify(bot.logDetail));
    //display:'flex',justifyContents:'center',alignContents:'center',
   return(
    <>
    
      {/* <div style={{display:'flex',height:'60px',backgroundColor:'white',alignContent:'center'}}>
        <h3 style={{textAlign:'center'}}>Logs</h3>
      </div> */}
      
      <div style={{display:'flex',backgroundColor:'skyblue',height:'59px',borderRadius:'10px',alignItems:'center',justifyContent:'center'}}>
        <div>
        <h3>Logs</h3>
        </div>
      </div>

      <div style={{overflow:'auto',height:'540px'}}>
     
        <p>
        
        {
          bot.logDetail != undefined && bot.logDetail.map(i=>(
            <p>{i.logTime} : {i.logMessage}</p>
          ))
        }
        </p>
      </div>
      


      
    </>


    
   )
  }


  function getTableHeader(){

    return(
      <>
        <th>Bot</th>
        <th>Status</th>
        <th>Start Time</th>
        <th>End Time</th>
      </>
    )

  }

  function getRowStyle(botLog){
    let rowStyle={ 
        cursor:'pointer',
        // backgroundColor: botLog.status === "OK" ? '':'Red',
        borderRight: selectedBot.botName ===  botLog.botName?'5px solid  blue': '0px',
        // paddingLeft:'5px',
        // borderRadius:'5px'
       
    }
    return rowStyle;
  }

  function getStatusStyle(botLog){
    let statusStyle={
      color:botLog.status === "OK" ? 'Green':'Red'
    }
    return statusStyle;
  }

  function getTableBody(){

    
    return(
      <>
      {
        filteredBotLogSummary.map(botLog=>(
          <tr style={getRowStyle(botLog)} onClick={()=>onClickBotCardHandler(botLog)}>
            <td>{botLog.botName}<br/>
                {botLog.description}
            </td>
            <td style={getStatusStyle(botLog)}>{botLog.status}</td>
            <td>{botLog.startTime}</td>
            <td>{botLog.endTime}</td>
          </tr>
        ))
      }
      </>
    )
  }

  function getTableActions(){

    return(
      <RefreshButton onClickHandler={()=>setBotLogSummaryChanged(true)}/>
    )

  }


  const onSelectEnv = (e)=>{
    e.preventDefault();
    console.log(`onSelectEnv ${e.target.value}`)
    setSelectedEnv(e.target.value);
    // getData(e.target.value);

  }

  // const envList = [
  //   "DEV",
  //   "QA",
  //   "UAT",
  //   "PROD"
  // ]


  return (
  
      <>
        <Loading loading={loading}/>
  
        <div style={{margin: 'auto',width: '5%', padding: '10px'}}>
        <SelectEnvironment selectedEnv={selectedEnv} onChangeHandler={onSelectEnv}/>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'50% 50%'}}>
            <div>
                <Table search={filterTable} 
                columns={getTableHeader()} 
                rows={getTableBody()} 
                tableActions={getTableActions()} 
                tbscrollstyle={{margin:'1px'}}
                tbstyle={{marginLeft:'1px',width:'97%'}}
                // loading={loading}
              
                />
            </div>
            <div>
                <div style={{marginRight:'20px',marginTop:'120px',height:'535px',width:'800px'}}>
                  <BotLogDetail bot={selectedBot}/>
                </div>
            </div>
              
        </div>
         

          
        
        
      </>
      
     
   
  )
}

   {/* <Table search={filterTable} 
                columns={getTableHeader()} 
                rows={getTableBody()} 
                tableActions={getTableActions()} 
                loading={loading}
              
                /> */}
 {/* <div style={{marginRight:'20px',marginTop:'110px',height:'535px',width:'800px'}}>
                  <BotLogDetail bot={selectedBot}/>


              </div> */}
 {/* <div style={{display:'flex'}}>
          <div style={{marginLeft:'10%',width:"330px"}}>
              <div className="search">
                  <TextField
                    label="Search"
                    id="outlined-basic"
                    size="small"
                    className={classes.root}
                    variant="outlined"
                    onChange={(e) => filterTable(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                <RefreshButton onClickHandler={()=>setBotLogSummaryChanged(true)}/>
              </div>
      
              <div className="tableFixedHead" style={{float:'left',paddingRight:'0px',marginRight:'5px'}}>
                  <table className="amictb">
                    <tr>
                      <th style={{height:'35px',width:'300px',textAlign:'center'}}>Bot Status</th>
                      <th></th>
                    </tr>
                    {filteredBotLogSummary.map((botLogItem) => (
                      <tr>
                        <td><BotCard botLog={botLogItem}/></td>
                
                      
                      </tr>
                    ))}
                  </table>
              </div>
          </div> */}
